import React, { Component, Fragment } from 'react';
import TitleContainer from './components/titleContainer';
import ContentView from './components/contentView';

const isMobile = /Android|webOS|iPhone|iPod|pad|ipad/i.test(navigator.userAgent);
export default class Cooperation extends Component {
  render() {
    const rows = [
      { img: require('./image/cooperation1.jpg'), title: '智慧门店', smallT: '万丽/如意/红领', left: true, content: '方案概述：智慧门店系统是一款针对服装新零售领域开发，为门店获客、销售、留存服务的定制系统。系统包含人脸识别系统、客户关系管理系统、云货架、智能量体、智能试衣等产品，贯穿于客户进店后的整个消费行为，可以为客户提供更精准服务的同时，实现客户数据的信息化管理，为门店销售预测和人员管理等提供决策依据。' },
      { img: require('./image/cooperation2.jpg'), title: '团装量体', smallT: '阳光/如意/碧海', left: false, content: '方案概述：智量智能量体设备便携版内置拍照量体系统和独立的网络模块，方便随时随地完成大批量的量体任务。阳光、如意、碧海等大型服装制造厂商在全国范围每年承接大量的团单服务，异地量体、服务人数多等问题一直困扰着企业的团单业务。通过采用智量的便携量体设备，解决了量体师服务半径和服务时间受限的问题，同时智量具有快速、精准、稳定的特点，减少了不必要的人工误差。'},
      { img: require('./image/cooperation3.jpg'), title: 'OMS系统', smallT: '海思堡牛仔/大连隆生', left: true, content: '方案概述：红创订单管理系统是红创科技与服装定制企业深度合作研发的一套可视化在线下单系统。该系统除了门店下单系统中必备的客户、商品、订单管理，在下单过程中集成3D可视化下单，接入自主研发的3D引擎，在显示效果和加载速度上进行优化处理，为客户下单提供可视化工具。'},
      { img: require('./image/cooperation4.jpg'), title: '定制电商', smallT: '裁圣/酷特云兰', left: false, content: '概述：酷特云兰APP开启了服装在线定制的先河，越来越多的定制品牌、门店希望通过电商拓展销售渠道。主流的电商APP无法满足商品定制、量体裁衣、定制状态跟踪等服装定制产业特有的行业痛点。红创多年来致力于服装定制行业的信息化改造服务，深谙定制行业对电商服务诉求的特殊性。在互联网和人工智能技术的助推下，红创现在有一套完整的电商SAAS服务，可以解决从商品定制、量体服务到订单跟踪的行业难题，帮助商家和消费者解决时间和空间的局限问题，促进购买转化，提升购物体验。'},
    ];
    return isMobile ? this.renderMobile(rows) : this.renderWeb(rows);
  }

  renderMobile = (rows) => (
    <Fragment>
      <div className='cooperation-t'>合作案例</div>
      <div className="mobile-coopera-area">
        {rows.map(({ img, left, title, smallT, content }) => (
          <div className="mobile-show-contain">
            <img src={img} className="mobile-show-contain-img" />
            <div className="coop-mobile-content">
              <div className="coop-mobile-item-row">
                <div className="coop-mobile-item-title">{title}</div>
                <div className="coop-mobile-item-subtitle">{smallT}</div>
              </div>
              <div className="coop-mobile-item-desc">{content}</div>
            </div>
          </div>
        ))}
      </div>
    </Fragment>
  )

  renderWeb = (rows) => (
    <Fragment>
      <TitleContainer slogan={require('./image/slogan-cooperation.svg')} tie={require('./image/cooperation-tie.svg')} />
      <div className="content-area">
        {rows.map(({ img, left, ...leftProps }) => (
          <div className="row-show-contain" style={{ flexDirection: left ? 'row' : 'row-reverse' }}>
            <img src={img} className="row-show-contain-img" style={left ? { marginRight: '40px' } : { marginLeft: '40px' }} />
            <ContentView {...leftProps} />
          </div>
        ))}
      </div>
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/Cooperation.js